namespace GeniuzPOS.Inventory {
    export class IcStockSetAssembleColumns {
        static columnsKey = 'Inventory.IcStockSetAssemble';
    }
}
